<template>
	<div class="mg-button-wrapper">
		<v-btn elevation="0"
			@click="$emit('click')"
			v-if="!circle"
			:class="'mg-button ' +
				(small ? 'mgButtonSmall ' : ' ')  +
				(alt ? 'alt ' : ' ') +
				(alt2 ? 'alt2 ' : ' ') +
				(outline ? 'outline ' : ' ') +
				(textOnly ? 'textOnly ' : ' ') +
				(fullWidth ? 'fullWidth ' : ' ') +
				(stacked ? 'mgButtonStacked ' : ' ') +
				(closerStack ? 'mgButtonCloserStack ' : ' ') +
				(noCaps ? 'mgButtonNoCaps ' : ' ') +
				(backgroundColor ? 'custom-bg ' : ' ')"
			:disabled="disabled"
			:variant="textOnly ? 'text' : undefined"
			:style="backgroundColor ? { '--custom-bg-color': backgroundColor } : {}"
		>
			<div v-if="!small && !circle" class="button-content">
				<div class="center-group">
					<img v-if="icon && !icon.startsWith('mdi-')" class="leftIcon" :src="icon" />
					<v-icon v-if="icon && icon.startsWith('mdi-')" class="leftIcon" :icon="icon" />
					<span class="textCol">{{text}}</span>
				</div>
				<div v-if="arrow || open || plus" class="rightIconCol">
					<img v-if="arrow" :class="['arrow', 'rightIcon', !alt && !alt2 && !outline ? 'white-arrow' : '']" :src="(alt || alt2 || outline ? require('@/assets/arrow-right.png') : require('@/assets/light-arrow-right.png'))" />
					<img v-if="open" class="open rightIcon" :src="(alt || alt2 || outline ? require('@/assets/chevron-down.png') : require('@/assets/chevron-down.png'))"/>
					<img v-if="plus" class="plus rightIcon" :src="(alt || alt2 || outline ? require('@/assets/plus-inverted.png') : require('@/assets/plus-inverted.png'))"/>
				</div>
			</div>
			<div v-if="small">
				{{ text }}
			</div>
		</v-btn>

		<v-btn @click="$emit('click')" v-if="circle" :color="color ? color : (alt ? '#E0C5C8' : '#281C3B')" :icon="icon" :density="small ? 'compact': 'default'"></v-btn>
	</div>
</template>

<script>
export default {
	name: "MGButton",
	props: {
		text: {
			type: String,
			default: ''
		},
		outline: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		arrow: {
			type: Boolean,
			default: false
		},
		alt: {
			type: Boolean,
			default: false
		},
		alt2: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: ''
		},
		open: {
			type: Boolean,
			default: false
		},
		circle: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		fullWidth: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: ''
		},
		stacked: {
			type: Boolean,
			default: false
		},
		closerStack: {
			type: Boolean,
			default: false
		},
		textOnly: {
			type: Boolean,
			default: false
		},
		noCaps: {
			type: Boolean,
			default: false
		},
		plus: {
			type: Boolean,
			default: false
		},
		leftIconSize: {
			type: [String, Number],
			default: 30
		},
		backgroundColor: {
			type: String,
			default: ''
		}
	},
	emits: ['click'],
	data() {
		return{
		}
	},
	computed: {
	},
	methods: {
		onLoad() {
	
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.mg-button-wrapper {
	display: contents;
}

.fullWidth {
	width: 100% !important;
}

.mgButtonSmall
{
	width: unset !important;
	height: 40px !important;
}

.mgButtonNoCaps {
	text-transform: none !important;
}

.mgButtonStacked
{
	margin-top: 15px !important;
}

.mgButtonCloserStack
{
	margin-top: 5px !important;
}

.button-content {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	position: relative;
}

.center-group {
	display: flex;
	align-items: center;
}

.rightIconCol {
	position: absolute;
	right: -12px;
	display: flex;
	align-items: center;
}

.rightIcon {
}

.leftIcon {
	width: v-bind("(leftIconSize || 30) + 'px'");
	margin-right: 4px;
}

.textCol {
	letter-spacing: normal !important;
}

.alt {
	background: linear-gradient(243.52deg, #FCE5D4 18.85%, #E0C5C8 81.37%) !important;
	color: var(--text-color) !important;
}

.alt2 {
	background: #41365508 !important;
	color: var(--text-color) !important;
}

.mg-button:not(.alt):not(.alt2):not(.outline):not(.textOnly):not(.custom-bg) {
	background: var(--background-color-primary) !important;
	color: white !important;
}

.mg-button.custom-bg {
	background: var(--custom-bg-color) !important;
	color: white !important;
}

.arrow {
	height: 12px;
	width: 18px;
}

.white-arrow {
	filter: brightness(0) invert(1);
}

.open {
	height: 8px;
}

.plus {
	height: 30px;
	width: 30px;
	margin-left: 5px;
}

.mg-button,
.mgButtonSmall,
.textCol {
letter-spacing: normal !important;
font-weight: bold !important;
}

/* Responsive: hide left icon on small screens */
@media (max-width: 300px) {
	.leftIcon {
		display: none !important;
	}
}

</style>